import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=01ce06f4&scoped=true"
import script from "./Logo.js?vue&type=script&lang=js&external"
export * from "./Logo.js?vue&type=script&lang=js&external"
import style0 from "./Logo.scss?vue&type=style&index=0&id=01ce06f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce06f4",
  null
  
)

export default component.exports